import React from 'react';
import styled from '@emotion/styled';
import { Table } from 'antd';
import { useTranslation } from 'react-i18next';
import { USER_PROFILE } from '../../../constants/define/translation';
import { CommonColumn } from '../shared-column';
import { ActionsColumn } from './columns';

export const GolfProfileTable = (prop: any) => {
  const { userProfile } = prop;
  const { golferProfile } = userProfile;
  const { t } = useTranslation(USER_PROFILE);
  const { Column } = Table;

  const records: any = [
    {
      description: 'Rounds Per Month',
      value: golferProfile?.roundsPerMonth,
    },
    {
      description: 'Typical 7 Iron Distance',
      value: golferProfile?.typical7IronDistance,
    },
    {
      description: 'Typical Driver Distance',
      value: golferProfile?.typicalDriverDistance,
    },
    {
      description: 'Maximum Driver Distance',
      value: golferProfile?.maximumDriverDistance,
    },
    {
      description: 'Strokes Gained Baseline',
      value: golferProfile?.strokesGainedBaseline,
    },
    {
      description: 'Target Score',
      value: golferProfile?.targetScore,
    },
    {
      description: 'Average Score',
      value: golferProfile?.averageScoreRange,
    },
    {
      description: 'Input Handicap',
      value: golferProfile?.newHandicap?.userInputHandicap,
    },
    {
      description: 'Calculated Handicap',
      value: golferProfile?.newHandicap?.tmCalculatedHandicap,
    },
    {
      description: 'Years Playing',
      value: golferProfile?.timePlayingGolf?.value,
    },
    {
      description: 'Strongest Area',
      value: golferProfile?.strongestArea,
    },
    {
      description: 'Weakest Area',
      value: golferProfile?.weakestArea,
    },
    {
      description: 'Scariest Shot',
      value: golferProfile?.mostScaredShot,
    },
    {
      description: 'Shot Shape',
      value: golferProfile?.shotShape,
    },
    {
      description: 'Ball Strike',
      value: golferProfile?.ballStrike,
    },
    {
      description: 'Mis-hit',
      value: golferProfile?.misHit,
    },
    {
      description: 'Eliminate',
      value: golferProfile?.avoidShot,
    },
    {
      description: 'Measurement Units',
      value: golferProfile?.measurementUnits,
    },
    {
      description: 'Favorite Players',
      value: golferProfile?.favoriteTeamMember,
    },
    {
      description: 'Speed Measurement Unit',
      value: golferProfile?.speedMeasurementUnit,
    },
    {
      description: 'Height',
      value: golferProfile?.height,
    },
    {
      description: 'Home Course',
      value: golferProfile?.homeCourse,
    },
    {
      description: 'iGolf Course ID',
      value: golferProfile?.iGolfCourseId,
    },
    {
      description: 'Handedness',
      value: golferProfile?.handed,
    },
  ];
  const loading = false;

  return (
    <>
      <StyledTable dataSource={records} loading={loading} rowKey="id" pagination={false}>
        <Column
          title={t('table.title.description')}
          width={200}
          dataIndex="description"
          key="description"
          render={value => <CommonColumn value={value} />}
          align="center"
        />
        <Column
          title={t('table.title.value')}
          width={200}
          dataIndex="value"
          key="value"
          render={value => <CommonColumn value={value} />}
          align="center"
          className="fcmToken"
          ellipsis
        />
        <Column
          title={t('table.title.action')}
          width={200}
          dataIndex="action"
          key="action"
          render={(value, record) => <ActionsColumn record={record} />}
          align="center"
        />
      </StyledTable>
    </>
  );
};

const StyledTable = styled(Table)`
  .fcmToken > div {
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .tableGolf {
    padding: 0 1rem;
  }
`;
